import {
  Settings
} from '../store/namespace-helper'

export const initialLoadingMixin = {
  data () {
    return {
      timeoutObj: null,
      initialLoading: true,
      timeoutMsec: 1200
    }
  },
  methods: {
    initialLoadingTimeout (timeout) {
      this.timeoutMsec = timeout
      this.extendTimeout()
    },
    resetInitialLoadingState () {
      clearTimeout(this.timeoutObj)
      this.timeoutObj = null
      this.initialLoading = true
    },
    extendTimeout () {
      this.resetInitialLoadingState()
      this.timeoutObj = setTimeout(() => {
        if (this.loadingFromStore === true) {
          this.extendTimeout()
        } else {
          this.initialLoading = false
        }
      }, this.timeoutMsec)
    }
  },
  computed: {
    getInitialLoading () {
      return this.initialLoading
    },
    loadingFromStore () {
      return this.$store.getters[Settings.getters.loading]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/initialLoadingMixin.js